<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Custom Map View Settings</span><br/>
    </div>
    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="80%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr>
            <td align="right" width="500">Enabled</td>
            <td width="800"><b-form-select v-model="model.maps_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Show Driver Phone</td>
            <td width="800"><b-form-select v-model="model.maps_show_driver_phone" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Available Using Start Time</td>
            <td width="800"><b-form-select v-model="model.maps_available_using_start_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Available Using Position Time</td>
            <td width="800"><b-form-select v-model="model.maps_available_using_position_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Available Minutes Before Booking</td>
            <td width="800">
              <b-form-input v-model="model.maps_available_minutes_before_booking" type="text" :state="numericState('maps_available_minutes_before_booking')" @input="validateNumeric('maps_available_minutes_before_booking', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('maps_available_minutes_before_booking')">{{ numericFeedback('maps_available_minutes_before_booking') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Available Minutes After Booking</td>
            <td width="800">
              <b-form-input v-model="model.maps_available_minutes_after_booking" type="text" :state="numericState('maps_available_minutes_after_booking')" @input="validateNumeric('maps_available_minutes_after_booking', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('maps_available_minutes_after_booking')">{{ numericFeedback('maps_available_minutes_after_booking') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.role == 'admin'">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr>
              <td align="right" width="500">Show ETAs (extra usage fees involved)</td>
              <td width="800"><b-form-select v-model="model.maps_show_pickup_dropoff_eta" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
        </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'

export default {
  name: 'tenant_config',
  mixins: [numericValidationMixin],
  components: {
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        //return value to object 
        //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
        for (const objkey of this.objectKeyList) {
          try {
            if (this.model[objkey] && this.model[objkey].trim && this.model[objkey].trim() !== '') {
              let setting = JSON.parse(this.model[objkey])
              this.model[objkey] = setting
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.load_data()
            return
          }
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
        this.load_data()
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

